import { laptopMax, laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { keyframes } from 'styled-components';

const fadeInAnimation = keyframes`
    0% {
      opacity: 0;
    }	
    8% {
      opacity: 1;
    }
    17% {
      opacity: 1;
    }
    25% {
      opacity: 0;
    }
`;

const workOutBreakpoint = (props: any) => {
  if (props.breakPoint) return `max-width:${props.breakPoint}`;
  return laptopMediumMax;
};

const BenefitsCheckListElementContainer = styled.li<{
  maxWidth?: number;
  breakPoint?: string;
}>`
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth}px;`}
  padding: 0 7px;

  @media screen and (${laptopMax}) {
    padding: inherit;
  }

  @media screen and (${(props) => workOutBreakpoint(props)}) {
    position: absolute;
    left: 50%;
    right: 0;
    top: 10px;
    transform: translateX(-50%);
    text-align: center;
    opacity: 0;
    width: 100%;
    height: 27px;

    &:nth-child(1) {
      animation: ${fadeInAnimation} 12s 0s infinite;
    }
    &:nth-child(2) {
      animation: ${fadeInAnimation} 12s 3s infinite;
    }
    &:nth-child(3) {
      animation: ${fadeInAnimation} 12s 6s infinite;
    }
    &:nth-child(4) {
      animation: ${fadeInAnimation} 12s 9s infinite;
    }
  }
`;

const IconContainer = styled.span`
  display: inline-flex;

  & > svg {
    margin-right: 11px;
  }
`;

export { IconContainer, BenefitsCheckListElementContainer };
